import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

import MGrid from 'components/MaterialUI/MGrid';
import MText from 'components/MaterialUI/MText';
import HotelCard from 'pages/Orders/HotelOrders/HotelInfo/HotelCard';

const HotelInfo = (props) => {
  const { orderItems, orderId, padding } = props;

  const { t } = useTranslation();

  return orderItems.map((orderItem, key) => (
    <MGrid {...{ key }} size={12} rowSpacing={3}>
      <Grid item children={<MText variant="h3" weight="bold" children={`${t('Orders.BookingsRooms')}`} />} />
      <HotelCard {...{ index: key + 1, orderId, orderItem, padding }} />
    </MGrid>
  ));
};

HotelInfo.propTypes = {
  orderId: PropTypes.any,
  orderItems: PropTypes.array,
  padding: PropTypes.any,
};

HotelInfo.defaultProps = {
  orderItems: [],
};

export default HotelInfo;
